import { Stepper, StepperStep } from '@customerio/pluma-components/react';
import type { WizardStep, WizardStepState } from '../steps';

type WizardStepperProps = {
  steps: readonly WizardStepState[];
  onSelect: (step: WizardStep) => void;
};

/** The step rail. A gated step is inert; the current one never is. */
export function WizardStepper({ steps, onSelect }: WizardStepperProps) {
  return (
    <Stepper layout="fit" size="sm" aria-label="Set up sync">
      {steps.map((step) => (
        <StepperStep
          key={step.id}
          data-test-stepper-step={step.label}
          label={step.label}
          status={step.status}
          isCurrent={step.isCurrent}
          isDisabled={step.isDisabled}
          onClick={() => onSelect(step.id)}
        />
      ))}
    </Stepper>
  );
}
